<header class="main-view" role="banner">
  <div
    class="image-cover"
    [style.background-image]="'url(' + imageLeft + ')'"
    role="img"
    [attr.aria-label]="translate.translations().imageDescriptionLeft"
  ></div>
  <div class="image-cover">
    <div
      [style.background-image]="'url(' + imageRight + ')'"
      role="img"
      [attr.aria-label]="translate.translations().imageDescriptionRight"
    ></div>
  </div>

  <div class="main-title">
    <h1 id="main-title" class="font-geograph-black">
      <span class="sr-only">Julio Graffin</span>
      <strong aria-hidden="true" class="animate-entry">JULIO</strong>
      <strong aria-hidden="true" class="animate-entry">GRAFFIN</strong>
    </h1>

    <p class="font-geograph-regular animate-entry">
      {{ translate.translations().mainTitle }}
    </p>

    <button
      class="scroll-down-button animate-entry"
      type="button"
      [attr.aria-label]="
        translate.translations().scrollDownButtonLabel || 'Rolar para projetos'
      "
      (click)="this.scrollService.scrollTo('projects')"
    >
      <span aria-hidden="true"></span>
    </button>
  </div>
</header>

<section class="main-projects" aria-labelledby="about-me">
  <span></span>

  <div #aboutMeSection id="about-me">
    <h2
      id="about-me"
      class="font-geograph-regular"
      [innerHTML]="translate.translations().headingProjects"
    ></h2>
    <p [innerHTML]="translate.translations().descriptionProjects"></p>

    <div class="w-full mx-auto flex items-center">
      <app-button
        class="transform lg:-translate-x-53 relative z-10"
        route="/quem-sou"
        [label]="translate.translations().seeMore"
        [isLink]="true"
        [hasIcon]="true"
      />
    </div>
  </div>

  <div
    id="projects"
    class="main-projects__gallery"
    #projects
    aria-labelledby="main-projects"
  >
    <h2 id="main-projects" class="font-geograph-regular sr-only"></h2>
    @defer {
      @if (featuredProject()) {
        <app-gallery
          [projects]="thumbnailsProjects()"
          [featured]="featuredProject()!"
          (projectSelected)="projectSelected($event)"
        />
      }
    }
  </div>
</section>

<section
  id="contact"
  class="main-testimonials"
  #contactSection
  aria-labelledby="testimonials"
>
  <span></span>
  <h1 class="sr-only">Julio Graffin</h1>
  <h2 class="sr-only">Analista Desenvolvedor Frontend Sr.</h2>

  @defer {
    <app-testimonials [data]="testimonialsList" />
  }
</section>
